"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = Loading;
var _react = _interopRequireDefault(require("react"));
var _grommet = require("grommet");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Loading(_ref) {
  var testId = _ref.testId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Box, {
    fill: "horizontal",
    height: "small",
    align: "center",
    justify: "center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_grommet.Spinner, {
      "data-testid": testId,
      size: "medium"
    })
  });
}
Loading.propTypes = {
  testId: _propTypes["default"].string
};